export default {
  presetSelectPlaceholder: 'Wybierz ustawienie wstępne',
  modalTitle: 'Przykładowe ustawienia wstępne',
  currentSelection: 'Aktualny wybór',
};
